import { render, staticRenderFns } from "./ReleaseDigitalDistributionEditPanelDialog.vue?vue&type=template&id=22a19b69"
import script from "./ReleaseDigitalDistributionEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./ReleaseDigitalDistributionEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports